<template>
    <div class="mwap_view">
        <div class="signup_body">
            <div class="upload-box">
                <van-image v-if="item.imgurl"  class="video"
                           :src="item.imgurl"/>
                <div class="input-box">
                    <div class="message">{{item.content}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import './index.less'
    import {Uploader, Image, Overlay, Loading, Picker, Popup, Field,Button} from 'vant';
    import MyVideo from '@/components/video'
    import {mapMutations,mapState} from 'vuex'
    export default {
        name: "signup",
        computed: {
            ...mapState({
                storeuserInfo: state => state.user.userInfo
            })
        },
        data() {
            return {
                id:"",
                item: {},
            }
        },
        components: {
            vanPicker: Picker,
            vanImage: Image,
            vanOverlay: Overlay,
            vanPopup: Popup,
            vanLoading: Loading,
            vanField:Field,
            vanUploader:Uploader,
            MyVideo,vanButton:Button
        },
        methods: {
            ...mapMutations([
                'setUserInfo'
            ]),
            onConfirm(date) {
                console.log(date)
                this.showPicker = false;
                this.form.type = date.value;
                this.form.label = date.label;
            },
            setUrl(e) {
                this.$toast.success('上传成功！');
                this.mediaurl = e
            },
            afterRead(file) {
                this.show = true
                this.$api.system.uploadfile(file).then(res => {
                    if (res.code * 1 === 200) {
                        this.show = false;
                        this.$toast.success('上传成功！');
                        this.mediaurl = res.data.url
                    }else{
                        this.$toast.error(res.message);
                    }
                });
            },
            getUserInfo() {
                this.$api.user.getUserInfo().then((res) => {
                    if (res.status * 1 === 200) {
                        this.userInfo = res.data
                        let {province, city, district, street, district_id} = res.data;
                        if (district_id) {
                            this.address = province + city + district + street
                            this.street =   street;
                        }
                    }
                })
            },


            colse(){
                this.showrule = false
                this.$router.replace({name: 'home', params: {id: this.id}})
            },
            del(){
                this.$toast.success('删除成功！');
                this.mediaurl = ''
            },
            getData() {

                let params = {id:this.id}
                this.$api.system.noticeView(params).then((res) => {
                    if (res.status * 1 === 200) {
                       this.item = res.data
                    }
                });
            },
        },
        mounted() {
           this.id = this.$route.params.id;
           this.getData();
        }
    }
</script>
<style lang="less" src="./view.less"></style>
